<div class="rewards-earning-summary-table">
  <div *ngIf="loading" class="table-loading">
    <app-loading-table-shimmer
      [columns]="shimmerColumns"
      [rows]="5"
      [showHeader]="true">
    </app-loading-table-shimmer>
  </div>

  <div *ngIf="!loading && items.length === 0" class="empty-state-container">
    <app-empty-result
      image="/assets/images/empty_screen.png"
      title="No rewards to display!"
      description="No employee rewards to show for the selected period."
      [showAction]="false">
    </app-empty-result>
  </div>

  <div *ngIf="!loading && items.length > 0" class="table-section">
    <div class="table-container">
      <div class="table-scroll-wrapper" #tableScrollWrapper>
        <table class="rewards-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Total Rewards Earned</th>
              <ng-container *ngFor="let column of columns; trackBy: trackByRuleId">
                <th>{{ ruleCountColumnHeader(column) }}</th>
                <th>{{ ruleAmountColumnHeader(column) }}</th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items; trackBy: trackByEmployeeId">
              <td>
                <div class="employee-info">
                  <div class="employee-avatar">
                    <img
                      *ngIf="item.employee.avatar"
                      [src]="item.employee.avatar"
                      [alt]="item.employee.name"
                      class="avatar-image">
                    <span *ngIf="!item.employee.avatar" class="avatar-initials">
                      {{ getEmployeeInitials(item.employee.name) }}
                    </span>
                  </div>
                  <div class="employee-details">
                    <div class="employee-name">{{ item.employee.name }}</div>
                    <div class="employee-id" *ngIf="item.employee.emp_id">
                      {{ item.employee.emp_id }}
                    </div>
                    <div class="employee-id" *ngIf="!item.employee.emp_id">
                      {{ item.employee.employee_id }}
                    </div>
                  </div>
                </div>
              </td>
              <td data-label="Total Rewards Earned">
                <div class="reward-amount total-reward">
                  {{ formatSummaryCurrency(item.total_rewards) }}
                </div>
              </td>
              <ng-container *ngFor="let column of columns; trackBy: trackByRuleId">
                <td [attr.data-label]="ruleCountColumnHeader(column)">
                  {{ getRuleCount(item, column.rule_id) }}
                </td>
                <td [attr.data-label]="ruleAmountColumnHeader(column)">
                  <div class="reward-amount">
                    {{ getRuleAmount(item, column.rule_id) }}
                  </div>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
